import React from 'react';

import createCtx from 'coreUtils/createCtx';

import {IPathnameContextProps} from './IPathContext';

export const [usePathContext, PathnameContext] = createCtx<IPathnameContextProps>();

export const PathnameProvider = ({pathname, children}: IPathnameContextProps) => {
	return (
		<PathnameContext value={{pathname}}>
			{children}
		</PathnameContext>
	);
};
